<template>
    <div class="card">
        <table class="table text-align-center">
            <thead>
                <tr>
                    <th>BUNCH INFO</th>
                    <th v-for="n in BunchDataInfo.length" :key="'bunchInfo'+n">{{ n }}</th>
                    <th>MIN</th>
                    <th>MAX</th>
                    <th>MEANS</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>bwt</td>
                    <td v-for="(BunchData, index) in BunchDataInfo" :key="'bwt'+index">{{ BunchData.bwt }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>espkwt</td>
                    <td v-for="(BunchData, index) in BunchDataInfo" :key="'espkwt'+index">{{ BunchData.espkwt }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>etfwt</td>
                    <td v-for="(BunchData, index) in BunchDataInfo" :key="'etfwt'+index">{{ BunchData.etfwt }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>etmwt</td>
                    <td v-for="(BunchData, index) in BunchDataInfo" :key="'etmwt'+index">{{ BunchData.etmwt }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>etwt</td>
                    <td v-for="(BunchData, index) in BunchDataInfo" :key="'etwt'+index">{{ BunchData.etwt }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>ffwt</td>
                    <td v-for="(BunchData, index) in BunchDataInfo" :key="'ffwt'+index">{{ BunchData.ffwt }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>fnwt</td>
                    <td v-for="(BunchData, index) in BunchDataInfo" :key="'fnwt'+index">{{ BunchData.fnwt }}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: ["palmID","TrialId"],
    data () {
        return {
            msg: "Action",
            BunchDataInfo: "",
        };
    },
    mounted() {
        var self = this;
        this.$nextTick(function () {
            self.getBunchData();
        });
    },
    methods: {
        getBunchData() {
            var self = this;
            axios({
				    method: "GET",
				    url: "BunchData/GetAll",
				    params: {
				      PalmId: self.palmID,
				      TrialId: self.TrialId
				    }
            })
                .then(function (response) {
                    self.BunchDataInfo = response.data.result.items;
                });
        },
    }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/FieldData/BunchInfo.vue